import React from 'react';

export default function Label(props) {
  return (
    <svg width="140px" height="14px" viewBox="0 0 128 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
        {/* Generator: Sketch 61.2 (89653) - https://sketch.com */}
        <title>Group 11</title>
      <desc>Created with Sketch.</desc>
      <g id="🖥-Wireframes-Desktop" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Activities-Protoype-Timeline-dropdown-strands" transform="translate(-219.000000, -1061.000000)">
          <rect id="Rectangle" fill="#00458C" opacity="0.03" x={210} y={788} width={950} height={324} rx={9} />
          <g id="Group-11" transform="translate(219.000000, 1060.000000)">
            <text id="Who’s-our-partner?" fontFamily="Inter-Bold, Inter" fontSize={12} fontWeight="bold" fill="#444444">
              <tspan x={15} y={12}>{props.title}</tspan>
            </text>
            <g id="Group" transform="translate(0.000000, 1.000000)" fill="rgb(185, 206, 177)" fillRule="nonzero">
              <path d="M0,6.17812338 C2.63054435,2.30937446 4.63054435,0.375 6,0.375 C7.36945564,0.375 9.36945563,2.30937446 12,6.17812338 C9.36458332,9.80937442 7.36458333,11.625 6,11.625 C4.63541667,11.625 2.63541667,9.80937442 0,6.17812338 Z" id="Path" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
